import ReactDOM from 'react-dom'
import { Router } from 'react-router-dom'
import ReactModal from 'react-modal'
import * as Sentry from '@sentry/react'
import TagManager from 'react-gtm-module'
import mixpanel from 'mixpanel-browser'
import './index.css'
import history from './lib/history'
import { EnvironmentContext } from './lib/hooks/useEnvironment'
import { getEnvironment } from './lib/environment'
import Root from './Root'

const auth0Domain = import.meta.env.VITE_AUTH0_DOMAIN
const auth0ClientId = import.meta.env.VITE_AUTH0_CLIENT_ID
const auth0Audience = import.meta.env.VITE_AUTH0_AUDIENCE
const sentryDsn = import.meta.env.VITE_SENTRY_DSN
const buildEnv = import.meta.env.VITE_BUILD_ENVIRONMENT
const mixpanelToken = import.meta.env.VITE_MIXPANEL_TOKEN
const currentEnvironment = getEnvironment()
const tagManagerMap: Map<string, string> = new Map([
  ['uta', 'GTM-5HL3VM4V'],
  ['utadev', 'GTM-5HL3VM4V'],
  ['utatest', 'GTM-5HL3VM4V']
])

const tagManagerArgs = {
  gtmId: tagManagerMap.get(currentEnvironment) || 'GTM-ND7Z5PT',
  dataLayer: {
    institution: currentEnvironment
  }
}
TagManager.initialize(tagManagerArgs)

mixpanel.init(mixpanelToken || '')

Sentry.init({
  dsn: sentryDsn,
  // This enables automatic instrumentation
  environment: buildEnv,
  integrations: [Sentry.reactRouterV5BrowserTracingIntegration({ history })],
  // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#enabled
  enabled: false,
  // error sample rate
  sampleRate: 1.0,
  // To set a uniform sample rate
  tracesSampleRate: 0.2
})

if (!auth0Domain || !auth0ClientId || !auth0Audience) {
  throw new Error('missing env vars')
}

ReactDOM.render(
  <EnvironmentContext.Provider value={getEnvironment()}>
    <Router history={history}>
      <Root />
    </Router>
  </EnvironmentContext.Provider>,
  document.getElementById('root')
)

/**
 * Necessary implementation for screen-readers. Read more:
 * ttp://reactcommunity.org/react-modal/accessibility/#app-element
 */
ReactModal.setAppElement(`#root`)
